const createMallIntegration = async ({ params, api }) => {
  return await api('mallIntegration', { body: params.data, method: 'POST' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default createMallIntegration;